import React from 'react';
import { Alert, Button, Drawer, Form, Input, InputNumber, Select } from 'antd';

const { Option } = Select;

export default function OrderShipmentCreateDrawer(props) {
    const {
        visible,
        onClose,
        onSubmit,
        availableProviders = [],
        order,
        saving,
        serviceOptions = [],
        feeQuote,
        viettelProvinces = [],
        viettelWards = [],
        onProviderChange,
        onProvinceChange,
        onLoadViettelQuote,
        onLoadViettelLocations
    } = props;

    const [form] = Form.useForm();

    return (
        <Drawer
            title="Tạo shipment"
            width={520}
            visible={visible}
            onClose={onClose}
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={{
                    provider: availableProviders[0] || undefined,
                    recipient_name: order && order.customer ? order.customer.name || '' : '',
                    phone: order && order.customer ? order.customer.phone || '' : '',
                    address_line: order && order.customer ? order.customer.address_line || '' : '',
                    cod_amount: order && order.pricing ? order.pricing.grand_total || 0 : 0,
                    delivery_note: '',
                    service_code: '',
                    extra_service_code: '',
                    province_id: order && order.customer && order.customer.province ? order.customer.province.id || undefined : undefined,
                    ward_id: order && order.customer && order.customer.ward ? order.customer.ward.id || undefined : undefined
                }}
                onFinish={onSubmit}
            >
                <Form.Item name="provider" label="Provider" rules={[{ required: true, message: 'Chọn provider' }]}>
                    <Select placeholder="Chọn provider" onChange={onProviderChange}>
                        {availableProviders.map((item) => <Option key={item} value={item}>{item}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item name="recipient_name" label="Người nhận" rules={[{ required: true, message: 'Nhập người nhận' }]}>
                    <Input />
                </Form.Item>
                <Form.Item name="phone" label="Số điện thoại" rules={[{ required: true, message: 'Nhập số điện thoại' }]}>
                    <Input />
                </Form.Item>
                <Form.Item name="address_line" label="Địa chỉ" rules={[{ required: true, message: 'Nhập địa chỉ' }]}>
                    <Input.TextArea rows={3} />
                </Form.Item>
                <Form.Item name="province_id" label="Tỉnh/Thành phố" rules={[{ required: true, message: 'Chọn tỉnh/thành phố' }]}>
                    <Select
                        showSearch
                        optionFilterProp="children"
                        placeholder="Chọn tỉnh/thành phố"
                        onChange={(provinceId) => {
                            form.setFieldsValue({ ward_id: undefined });
                            if (onProvinceChange) onProvinceChange(provinceId);
                        }}
                    >
                        {viettelProvinces.map((item) => <Option key={item.id} value={item.id}>{item.name}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item name="ward_id" label="Phường/Xã" rules={[{ required: true, message: 'Chọn phường/xã' }]}>
                    <Select showSearch optionFilterProp="children" placeholder="Chọn phường/xã">
                        {viettelWards.map((item) => <Option key={item.id} value={item.id}>{item.name}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item name="extra_service_code" label="Dịch vụ cộng thêm Viettel">
                    <Select placeholder="Chọn dịch vụ cộng thêm">
                        <Option value="">Không chọn</Option>
                    </Select>
                </Form.Item>
                <div style={{ marginBottom: 12 }}>
                    <Button onClick={onLoadViettelLocations}>Tải lại danh mục địa chỉ</Button>
                </div>
                <Form.Item name="cod_amount" label="COD">
                    <InputNumber min={0} style={{ width: '100%' }} />
                </Form.Item>
                <Form.Item name="delivery_note" label="Ghi chú giao hàng">
                    <Input.TextArea rows={2} />
                </Form.Item>
                <Form.Item name="service_code" label="Dịch vụ Viettel">
                    <Select placeholder="Chọn dịch vụ">
                        {serviceOptions.map((item) => <Option key={item.MA_DV_CHINH} value={item.MA_DV_CHINH}>{item.TEN_DICHVU || item.MA_DV_CHINH}</Option>)}
                    </Select>
                </Form.Item>
                <div style={{ marginBottom: 12 }}>
                    <Button onClick={() => onLoadViettelQuote(form.getFieldsValue())}>Lấy dịch vụ & cước Viettel</Button>
                </div>
                {feeQuote ? <Alert type="info" message={`Cước dự kiến: ${feeQuote.MONEY_TOTAL || 0}`} /> : null}
                <div className="d-flex justify-content-end" style={{ gap: 8, marginTop: 12 }}>
                    <Button onClick={onClose}>Đóng</Button>
                    <Button type="primary" htmlType="submit" loading={saving}>Tạo shipment</Button>
                </div>
            </Form>
        </Drawer>
    );
}
